'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _onlinepbxWarning = require('./onlinepbx-warning');

var _onlinepbxWarning2 = _interopRequireDefault(_onlinepbxWarning);

var _onlinepbxInfo = require('./onlinepbx-info');

var _onlinepbxInfo2 = _interopRequireDefault(_onlinepbxInfo);

var _generatePasswordBrowser = require('generate-password-browser');

var _reactCopyToClipboard = require('react-copy-to-clipboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EyeIcon = function () {
  function EyeIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M.833 10S4.167 3.333 10 3.333 19.167 10 19.167 10 15.833 16.667 10 16.667.833 10 .833 10z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return EyeIcon;
}();

EyeIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var EyeOffIcon = function () {
  function EyeOffIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M14.95 14.95A8.392 8.392 0 0 1 10 16.667C4.167 16.667.833 10 .833 10A15.375 15.375 0 0 1 5.05 5.05m3.2-1.517a7.6 7.6 0 0 1 1.75-.2c5.833 0 9.167 6.667 9.167 6.667a15.417 15.417 0 0 1-1.8 2.658m-5.6-.891a2.5 2.5 0 1 1-3.534-3.534m-7.4-7.4l18.334 18.334',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return EyeOffIcon;
}();

EyeOffIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var SearchIcon = function () {
  function SearchIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        clipRule: 'evenodd',
        d: 'M8.75 15a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M17.5 17.5l-4.333-4.333',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return SearchIcon;
}();

SearchIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var GenerateIcon = function () {
  function GenerateIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M19.167 4.167v4.166H15M.833 15.833v-4.166H5',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M2.925 7.5A7.5 7.5 0 0 1 15.3 4.7l3.867 3.633M.833 11.667L4.7 15.3a7.5 7.5 0 0 0 12.375-2.8',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M12.43 9.653H7.57a.694.694 0 0 0-.695.694v2.43c0 .384.31.695.694.695h4.862c.383 0 .694-.31.694-.694v-2.43a.694.694 0 0 0-.694-.695z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M8.264 9.653v-1.39a1.736 1.736 0 0 1 3.472 0v1.39',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return GenerateIcon;
}();

GenerateIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var CrossIcon = function () {
  function CrossIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 5L5 15M5 5l10 10',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CrossIcon;
}();

CrossIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};
var OnlinepbxInput = (_temp2 = _class = function (_React$Component) {
  _inherits(OnlinepbxInput, _React$Component);

  function OnlinepbxInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OnlinepbxInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnlinepbxInput.__proto__ || Object.getPrototypeOf(OnlinepbxInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocus: false,
      isHover: false,
      value: null
    }, _this.isCursor = true, _this.onMouseLeaveWrapper = function () {
      _this.props.isCross && _this.setState(function (prevState) {
        return _extends({}, prevState, { isHover: false });
      });
    }, _this.onMouseEnterWrapper = function () {
      _this.props.isCross && _this.setState(function (prevState) {
        return _extends({}, prevState, { isHover: true });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OnlinepbxInput, [{
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return this.props.value !== nextProps.value || this.props.warningText !== nextProps.warningText || this.props.search !== nextProps.search || !!this.props.isEye !== !!nextProps.isEye || this.props.placeholder !== nextProps.placeholder || this.props.id !== nextProps.id || this.props.label !== nextProps.label || this.state.isFocus !== nextState.isFocus || !!this.props.disabled !== !!nextProps.disabled || !!this.props.fullText !== !!nextProps.fullText || !!this.props.dark !== !!nextProps.dark || !!this.props.isCross !== !!nextProps.isCross || !!this.props.isControlValue !== !!nextProps.isControlValue || !!this.props.showAwaysPlaceholder !== !!nextProps.showAwaysPlaceholder || !!this.props.childrenAfterIcons !== !!nextProps.childrenAfterIcons || this.state.value !== nextState.value || this.state.isHover !== nextState.isHover || !!(this.props.units || this.props.isGenerate || this.props.isEye) && this.state.isFocus !== nextState.isFocus;
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this,
            _classNames2,
            _classNames3,
            _classNames4;

        var _props = this.props,
            className = _props.className,
            disabled = _props.disabled,
            label = _props.label,
            _onBlur = _props.onBlur,
            dataTest = _props.dataTest,
            _onChange = _props.onChange,
            _onInput = _props.onInput,
            _onFocus = _props.onFocus,
            styleInput = _props.styleInput,
            warningText = _props.warningText,
            style = _props.style,
            fullText = _props.fullText,
            _props$value = _props.value,
            value = _props$value === undefined ? '' : _props$value,
            dark = _props.dark,
            warning = _props.warning,
            autofocus = _props.autofocus,
            maxLength = _props.maxLength,
            onKeyDown = _props.onKeyDown,
            id = _props.id,
            isEye = _props.isEye,
            _props$isPassword = _props.isPassword,
            isPassword = _props$isPassword === undefined ? isEye : _props$isPassword,
            tabIndex = _props.tabIndex,
            isGenerate = _props.isGenerate,
            customIcon = _props.customIcon,
            customIconTitle = _props.customIconTitle,
            onClickCustomIcon = _props.onClickCustomIcon,
            focusOnCustomIconClick = _props.focusOnCustomIconClick,
            search = _props.search,
            autoComplete = _props.autoComplete,
            isCross = _props.isCross,
            onClickCross = _props.onClickCross,
            units = _props.units,
            onClickGenerate = _props.onClickGenerate,
            name = _props.name,
            isControlValue = _props.isControlValue,
            filterValue = _props.filterValue,
            showAwaysPlaceholder = _props.showAwaysPlaceholder,
            warningOpenDefault = _props.warningOpenDefault,
            _props$classNameCompo = _props.classNameComponent,
            classNameComponent = _props$classNameCompo === undefined ? 'onlinepbx__lib__input' : _props$classNameCompo,
            infoText = _props.infoText,
            infoTextMaxWidth = _props.infoTextMaxWidth,
            warningTextWidth = _props.warningTextWidth,
            infoChildrenIcon = _props.infoChildrenIcon,
            childrenAfterIcons = _props.childrenAfterIcons,
            childrenBeforeIcons = _props.childrenBeforeIcons,
            showAlwaysCross = _props.showAlwaysCross,
            warningIsOnlyDown = _props.warningIsOnlyDown,
            customInputType = _props.customInputType,
            inputMode = _props.inputMode,
            pattern = _props.pattern;

        var placeholder = this.state.isFocus || !this.props.unfocusedPlaceholder ? this.props.placeholder : this.props.unfocusedPlaceholder;
        var generationValue = (0, _generatePasswordBrowser.generate)({ numbers: true, length: 16 });

        return _react2['default'].createElement(
          'div',
          { className: String(classNameComponent) + '__wrapper', onMouseLeave: this.onMouseLeaveWrapper, onMouseEnter: this.onMouseEnterWrapper },
          isPassword && !autoComplete && _react2['default'].createElement(
            'div',
            {
              style: { height: 0, opacity: 0, position: 'absolute', zIndex: 0 } },
            _react2['default'].createElement('input', {
              type: 'email',
              value: '',
              tabIndex: '-1'
            }),
            _react2['default'].createElement('input', {
              type: 'password',
              value: '',
              tabIndex: '-1'
            })
          ),
          _react2['default'].createElement(
            'div',
            { className: '' + String(classNameComponent) },
            _react2['default'].createElement(
              'div',
              {
                style: style,
                className: (0, _classnames2['default'])(String(classNameComponent) + '__container', _defineProperty({}, String(classNameComponent) + '__container__full', fullText)) },
              _react2['default'].createElement(
                'div',
                { className: String(classNameComponent) + '__field__wrapper' },
                _react2['default'].createElement(
                  'div',
                  { className: String(classNameComponent) + '__field__container' },
                  search && _react2['default'].createElement(SearchIcon, {
                    onClick: function () {
                      function onClick() {
                        return _this2.input.focus();
                      }

                      return onClick;
                    }(),
                    className: String(classNameComponent) + '__search' }),
                  _react2['default'].createElement('input', _extends({}, maxLength ? { maxLength: maxLength } : {}, typeof onKeyDown === 'function' ? { onKeyDown: onKeyDown } : {}, {
                    tabIndex: tabIndex,
                    autoFocus: autofocus,
                    id: id,
                    autoComplete: autoComplete,
                    name: name,
                    'data-test': dataTest,
                    style: styleInput,
                    title: this.input && this.input.type !== 'password' && value || '',
                    type: customInputType || isPassword && 'password' || 'text',
                    pattern: pattern,
                    inputMode: inputMode,
                    disabled: disabled,
                    ref: function () {
                      function ref(node) {
                        if (node && !_this2.input) {
                          _this2.forceUpdate();
                        }
                        _this2.input = node || _this2.input;
                      }

                      return ref;
                    }(),
                    value: value && !this.state.isFocus && units && value + (' ' + String(units)) || (this.state.value === null || isControlValue) && value || !isControlValue && this.state.value || '',
                    onChange: function () {
                      function onChange(evt) {
                        typeof _onChange === 'function' && _onChange(evt);
                        _this2.setState({ value: typeof filterValue === 'function' ? filterValue(evt.target.value) : evt.target.value });
                      }

                      return onChange;
                    }(),
                    onInput: function () {
                      function onInput(evt) {
                        typeof _onInput === 'function' && _onInput(evt);
                        _this2.setState({ value: typeof filterValue === 'function' ? filterValue(evt.target.value) : evt.target.value });
                      }

                      return onInput;
                    }(),
                    placeholder: label && this.state.isFocus && placeholder || showAwaysPlaceholder && placeholder || !label && placeholder || '',
                    onFocus: function () {
                      function onFocus(evt) {
                        typeof _onFocus === 'function' && _onFocus(evt);
                        !disabled && _this2.setState({ isFocus: true, isTime: true, value: null });
                      }

                      return onFocus;
                    }(),
                    onBlur: function () {
                      function onBlur(evt) {
                        typeof _onBlur === 'function' && _this2.isCursor && _onBlur(evt);
                        !disabled && _this2.isCursor && _this2.setState({ isFocus: false, isTime: false, value: null });
                      }

                      return onBlur;
                    }(),
                    className: (0, _classnames2['default'])(String(classNameComponent) + '__field', className, (_classNames2 = {}, _defineProperty(_classNames2, String(classNameComponent) + '__field__disabled', disabled), _defineProperty(_classNames2, String(classNameComponent) + '__field__full', fullText), _defineProperty(_classNames2, String(classNameComponent) + '__field__nolabel', !label), _defineProperty(_classNames2, String(classNameComponent) + '__field__search', search), _defineProperty(_classNames2, String(classNameComponent) + '__field__generate', isGenerate), _defineProperty(_classNames2, String(classNameComponent) + '__field__custom', customIcon), _defineProperty(_classNames2, String(classNameComponent) + '__field__cross', value && this.state.isFocus && isCross && !isGenerate && !isPassword), _defineProperty(_classNames2, String(classNameComponent) + '__field__warning', warningText || warning), _defineProperty(_classNames2, String(classNameComponent) + '__field__password', isPassword), _classNames2))
                  })),
                  label && _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])(String(classNameComponent) + '__label__wrapper', (_classNames3 = {}, _defineProperty(_classNames3, String(classNameComponent) + '__label__wrapper__focus', this.state.isFocus || (this.state.value === null ? value : this.state.value) || showAwaysPlaceholder && placeholder), _defineProperty(_classNames3, String(classNameComponent) + '__label__wrapper__search', search), _classNames3)) },
                    _react2['default'].createElement(
                      'div',
                      {
                        onClick: function () {
                          function onClick() {
                            !disabled && _this2.setState({ isTime: true });
                            _this2.input.focus();
                          }

                          return onClick;
                        }(),
                        className: (0, _classnames2['default'])(String(classNameComponent) + '__label', (_classNames4 = {}, _defineProperty(_classNames4, String(classNameComponent) + '__label__focus', this.state.isFocus || (this.state.value === null ? value : this.state.value) || showAwaysPlaceholder && placeholder), _defineProperty(_classNames4, String(classNameComponent) + '__label__focus__color', this.state.isFocus), _defineProperty(_classNames4, String(classNameComponent) + '__label__warning', warningText || warning), _defineProperty(_classNames4, String(classNameComponent) + '__label__dark', dark), _defineProperty(_classNames4, String(classNameComponent) + '__label__disabled', disabled), _classNames4)) },
                      label
                    )
                  ),
                  childrenBeforeIcons,
                  isGenerate && _react2['default'].createElement(
                    _reactCopyToClipboard.CopyToClipboard,
                    { text: generationValue },
                    _react2['default'].createElement(
                      'button',
                      {
                        title: '\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C',
                        className: String(classNameComponent) + '__generate',
                        onClick: function () {
                          function onClick(evt) {
                            _this2.setState({ value: generationValue });
                            typeof _onChange === 'function' && _onChange({ target: { value: generationValue } });
                            typeof onClickGenerate === 'function' && onClickGenerate();
                            _this2.input.focus();
                          }

                          return onClick;
                        }() },
                      _react2['default'].createElement(GenerateIcon, { className: String(classNameComponent) + '__generate__icon' })
                    )
                  ),
                  customIcon && _react2['default'].createElement(
                    'button',
                    {
                      title: customIconTitle || '',
                      className: String(classNameComponent) + '__custom',
                      onClick: function () {
                        function onClick(evt) {
                          typeof onClickCustomIcon === 'function' && onClickCustomIcon();
                          if (focusOnCustomIconClick) _this2.input.focus();
                        }

                        return onClick;
                      }() },
                    customIcon
                  ),
                  isEye && _react2['default'].createElement(
                    'button',
                    {
                      onClick: function () {
                        function onClick() {
                          if (_this2.input && _this2.input.type === 'text') {
                            _this2.input.type = 'password';
                          } else {
                            _this2.input.type = 'text';
                          }
                          _this2.input.focus();
                        }

                        return onClick;
                      }(),
                      className: String(classNameComponent) + '__eye' },
                    this.input && this.input.type === 'text' && _react2['default'].createElement(EyeOffIcon, { className: String(classNameComponent) + '__eye__icon' }) || _react2['default'].createElement(EyeIcon, { className: String(classNameComponent) + '__eye__icon' })
                  ),
                  isCross && (this.state.isFocus || this.state.isHover || showAlwaysCross) && value && _react2['default'].createElement(
                    'button',
                    {
                      onMouseEnter: function () {
                        function onMouseEnter() {
                          _this2.isCursor = false;
                        }

                        return onMouseEnter;
                      }(),
                      onMouseLeave: function () {
                        function onMouseLeave() {
                          _this2.isCursor = true;
                        }

                        return onMouseLeave;
                      }(),
                      onClick: function () {
                        function onClick(evt) {
                          typeof onClickCross === 'function' && onClickCross(evt);
                          _this2.input.value = '';
                          typeof _onChange === 'function' && _onChange({ target: { value: null } });
                          _this2.input.focus();
                          _this2.isCursor = true;
                          _this2.setState({ value: null });
                        }

                        return onClick;
                      }(),
                      title: '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C',
                      className: String(classNameComponent) + '__cross' },
                    _react2['default'].createElement(CrossIcon, { className: String(classNameComponent) + '__cross__icon' })
                  ),
                  warningText && _react2['default'].createElement(
                    'div',
                    { className: String(classNameComponent) + '__warning' },
                    _react2['default'].createElement(_onlinepbxWarning2['default'], { text: warningText, openDefault: warningOpenDefault, maxWidth: warningTextWidth, isOnlyDown: warningIsOnlyDown })
                  ),
                  !warningText && infoText && _react2['default'].createElement(
                    'div',
                    { className: String(classNameComponent) + '__info' },
                    _react2['default'].createElement(_onlinepbxInfo2['default'], { text: infoText, childrenIcon: infoChildrenIcon, maxWidth: infoTextMaxWidth })
                  ),
                  childrenAfterIcons
                )
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return OnlinepbxInput;
}(_react2['default'].Component), _class.defaultProps = {
  dependencies: false,
  tabIndex: '0',
  autofocus: false
}, _temp2);
exports['default'] = OnlinepbxInput;